import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { useDeleteMutation } from '../../hooks/useAuthenticatedMutation';
import useSnackbar from '../../hooks/useSnackbar';

const DeleteSegmentDialog = ({ onClose, segment, selectedSegment, onSelectSegment }) => {
    const { showSnackbar } = useSnackbar();
    const segmentDeleteMutation = useDeleteMutation(`segments/${segment.id}`, 'segments');

    const handleConfirm = e => {
        e.preventDefault();

        segmentDeleteMutation.mutate(
            {
                onSuccess: () => {
                    showSnackbar('Segment deleted', 'success');

                    if (segment.id === selectedSegment?.id) {
                        onSelectSegment(null);
                    }

                    onClose();

                }
            }
        );
    };

    //add loading state and await confirm?

    return (
        <Dialog onClose={onClose} open={true}>
            <DialogTitle>Delete Segment '{segment.name}'</DialogTitle>
            <DialogContent>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    Are you sure you want to delete this segment from your Account?
                </Alert>
                <DialogContentText>
                    Deleting a Segment does not delete any Contacts. They will remain in your account.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleConfirm}>Confirm Delete</Button>
                <Button variant="outlined" onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteSegmentDialog;